export default __webpack_public_path__ + "static/stock_mainscreen@2x-8d0268efbcddee202ebe3eb18e5e7fa4.png";